const COMPONENT_PREFIX = 'mwg-';

export function prefixClassName(name: string) {
  return `${COMPONENT_PREFIX}${name}`;
}
